import { StyledLink } from '@/components/styled-link';

import {
  AuthTemplate,
  FooterLinks,
} from '@/pages/unauthenticated/auth/components';

export default function CliErrorPage() {
  return (
    <AuthTemplate heading="Login failure" footer={<FooterLinks />}>
      <span className="text-sm">
        Please contact{' '}
        <StyledLink href="mailto:support@flagsync.com">
          support@flagsync.com
        </StyledLink>{' '}
        and we&#39;ll help you out.
      </span>
    </AuthTemplate>
  );
}
